<template>
    <div class="upload_div">
        <el-dropdown
            icon="el-icon-bottom"
            v-loading="loading"
            element-loading-spinner="el-icon-loading"
            style="margin-left: 10px"
            @command="handleUpload"
            :disabled="upload_disable"
        >
            <el-button type="primary"> 上传 <i class="el-icon-arrow-down el-icon--right"></i> </el-button>
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item icon="el-icon-bottom" command="downLoadInsertTemp" v-if="display_insert">新增模板</el-dropdown-item>
                <el-dropdown-item icon="el-icon-upload" v-if="display_insert">
                    <el-upload
                        ref="uploadInsert"
                        style="display: inline-block"
                        :limit="1"
                        action
                        name="file"
                        :auto-upload="true"
                        list-type="picture"
                        :show-file-list="false"
                        :http-request="uploadInsert"
                        accept=".csv"
                    >
                        批量新增
                    </el-upload>
                </el-dropdown-item>
                <el-dropdown-item icon="el-icon-bottom" command="downLoadUpdateTemp" v-if="display_update">更新模板</el-dropdown-item>
                <el-dropdown-item icon="el-icon-upload" v-if="display_update">
                    <el-upload
                        ref="uploadUpdate"
                        style="display: inline-block"
                        :limit="1"
                        action
                        name="file"
                        :auto-upload="true"
                        list-type="picture"
                        :show-file-list="false"
                        :http-request="uploadUpdate"
                        accept=".csv"
                    >
                        批量更新
                    </el-upload>
                </el-dropdown-item>

                <el-dropdown-item icon="el-icon-bottom" command="downLoadDeleteTemp" v-if="display_delete" divided>删除模板</el-dropdown-item>
                <el-dropdown-item icon="el-icon-upload" v-if="display_delete">
                    <el-upload
                        ref="uploadDelete"
                        style="display: inline-block"
                        :limit="1"
                        action
                        name="file"
                        :auto-upload="true"
                        list-type="picture"
                        :show-file-list="false"
                        :http-request="uploadDelete"
                        accept=".csv"
                    >
                        批量删除
                    </el-upload>
                </el-dropdown-item>

                <el-dropdown-item icon="el-icon-bottom" command="downLoadUpdateOrCreateTemp" v-if="display_updateOrCreate"
                    >新增/更新模板</el-dropdown-item
                >
                <el-dropdown-item icon="el-icon-upload" v-if="display_updateOrCreate">
                    <el-upload
                        ref="uploadUpdateOrCreate"
                        style="display: inline-block"
                        :limit="1"
                        action
                        name="file"
                        :auto-upload="true"
                        list-type="picture"
                        :show-file-list="false"
                        :http-request="uploadUpdateOrCreate"
                        accept=".csv"
                    >
                        批量新增/更新
                    </el-upload>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
export default {
    name: 'crmUpload',
    props: {
        obj: {
            type: String
        },
        queryParams: {
            type: Object
        },
        display_insert: {
            type: Boolean,
            default: true
        },
        display_update: {
            type: Boolean,
            default: true
        },
        display_delete: {
            type: Boolean,
            default: true
        },
        display_updateOrCreate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            upload_disable: false,
            loading: false
        };
    },
    methods: {
        uploadInsert(param) {
            this.onUpload('insert', param, this.$refs.uploadInsert);
        },
        uploadUpdate(param) {
            this.onUpload('update', param, this.$refs.uploadUpdate);
        },
        uploadDelete(param) {
            this.onUpload('delete', param, this.$refs.uploadDelete);
        },
        uploadUpdateOrCreate(param) {
            this.onUpload('updateOrCreate', param, this.$refs.uploadUpdateOrCreate);
        },
        handleUpload(command) {
            if (command == 'downLoadInsertTemp') {
                this.onDownTemplate('insert');
            } else if (command == 'downLoadUpdateTemp') {
                this.onDownTemplate('update');
            } else if (command == 'downLoadDeleteTemp') {
                this.onDownTemplate('delete');
            } else if (command == 'downLoadUpdateOrCreateTemp') {
                this.onDownTemplate('updateOrCreate');
            }
        },
        onDownTemplate(type) {
            this.upload_disable = true;
            this.loading = true;

            let method = 'downloadInsertTemplate';

            if (type == 'update') {
                method = 'downloadUpdateTemplate';
            } else if (type == 'delete') {
                method = 'downloadDeleteTemplate';
            } else if (type == 'updateOrCreate') {
                method = 'downloadUpdateOrCreateTemplate';
            }

            this.$api[method]({
                obj: this.obj,
                queryParams: this.queryParams || {}
            })
                .then((res) => {
                    this.$message({
                        message: '下载成功!',
                        type: 'success'
                    });
                    this.upload_disable = false;
                    this.loading = false;
                })
                .catch((error) => {
                    this.upload_disable = false;
                    this.loading = false;
                });

            return true;
        },
        onUpload(type, param, uploadObject) {
            this.upload_disable = true;
            this.loading = true;

            let method = 'uploadInsert';

            if (type == 'update') {
                method = 'uploadUpdate';
            } else if (type == 'delete') {
                method = 'uploadDelete';
            }else if (type == 'updateOrCreate') {
                method = 'uploadUpdateOrCreate';
            }

            var fileObj = param.file;
            let fileData = new FormData(); // FormData 对象
            fileData.append('file', fileObj); // 文件对象
            fileData.append('obj', this.obj);
            this.$api[method](fileData)
                .then((res) => {
                    uploadObject.clearFiles();

                    if (res.data.length == 0) {
                        this.$message.success('上传成功，请刷新页面');
                    } else {
                        this.$confirm('存在上传失败的数据，是否导出错误？', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning',
                            closeOnPressEscape: false,
                            closeOnClickModal: false
                        })
                            .then(() => {
                                this.$api
                                    .downloadErrorMessage(res.data)
                                    .then((r) => {
                                        this.$message.success('下载成功');
                                    })
                                    .catch((e) => {});
                            })
                            .catch(() => {});
                    }

                    this.upload_disable = false;
                    this.loading = false;
                })
                .catch((error) => {
                    uploadObject.clearFiles();
                    this.upload_disable = false;
                    this.loading = false;
                });
        }
    }
};
</script>

<style>
.upload_div .el-loading-spinner {
    top: 90% !important;
}
</style>